import type {KilnLayout} from '@domain/kiln-monitoring'

import {getIsDriveConfigValid} from './getIsDriveConfigValid'
import {getIsStationsConfigValid} from './getIsStationsConfigValid'
import {checkAreKilnDimensionsSetUp, getEmptyConfigValidation, checkIsNameSetUp} from './utils'

import type {KilnConfiguration} from '@kilnfeature/types'

export const getIsKilnConfigValid = (
  kilnLayout: KilnLayout,
  kilnConfiguration: KilnConfiguration
) => {
  if (Object.keys(kilnLayout).length === 0 || Object.keys(kilnConfiguration).length === 0) {
    return getEmptyConfigValidation()
  }

  const isKilnNameSetUp = checkIsNameSetUp(kilnConfiguration.name)

  const areKilnDimensionsSetUp = checkAreKilnDimensionsSetUp(kilnConfiguration)

  const {
    isDriveConfigVaid,
    details: {isDriveNameSetUp, areDriveBoundariesSetUp}
  } = getIsDriveConfigValid(kilnLayout, kilnConfiguration)

  const {
    isStationsConfigValid,
    details: {isMoreThanOneStation, areStationsNamesSetUp, areStationsBoundariesSetUp}
  } = getIsStationsConfigValid(kilnLayout, kilnConfiguration)

  const isKilnConfigValid =
    isKilnNameSetUp && areKilnDimensionsSetUp && isDriveConfigVaid && isStationsConfigValid

  return {
    isKilnConfigValid,
    details: {
      isKilnNameSetUp,
      areKilnDimensionsSetUp,
      isDriveNameSetUp,
      areDriveBoundariesSetUp,
      isMoreThanOneStation,
      areStationsNamesSetUp,
      areStationsBoundariesSetUp
    }
  }
}
